import { PAGE_VIEW_EVENT_NAME } from "@/apps/whiteLabelWebsite/whiteLabel/core/domain/tagManagementSystem/Events";
import tmsService from "@/apps/whiteLabelWebsite/whiteLabel/core/infrastructure/service/gtmService";

export type PageViewEvent = {
  page_path: string;
};

export const pushPageViewCommand = (input: PageViewEvent): void => {
  if (!input.page_path) {
    throw new Error("page_path must not be a falsy value");
  }
  tmsService.pushToDataLayer({
    ...input,
    event: PAGE_VIEW_EVENT_NAME,
  });
};
